// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"616cca98","455":"3f3dd1f4","488":"54c3ad86","977":"ffdb72dd"}[chunkId] + ".chunk.js";
};